import React from 'react';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
import { Section } from './Section';
const WHATSAPP_NUMBER = '911 2400 6361';
const WHATSAPP_URL = 'https://wa.me/5491124006361?text=Hola!%20Tengo%20una%20consulta%20sobre%20Diccionario%20Apple';
export function Contact() {
  return <Section className="bg-cream-50" data-id="element-82" data-mp="2w80ajhhj6y5l">
      <div className="rounded-[2rem] border border-ink-950/10 bg-white p-7 text-center sm:p-10" data-id="element-83" data-mp="2w91phx1o44sl">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent-deep" data-id="element-84" data-mp="3sx80d1p6ntfb">
          Contacto
        </p>
        <h2 className="mt-4 text-2xl font-extrabold leading-tight tracking-tight text-ink-950 sm:text-3xl" data-id="element-85" data-mp="3oy8wzlj3o4pz">
          ¿Tenés preguntas, dudas o consultas del contenido?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink-800/80 sm:text-base" data-id="element-86" data-mp="3f5td2io8t62g">
          Mandame un mensaje y te respondemos al toque: acceso, contenido, pago
          y devoluciones.
        </p>

        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="mt-7 inline-flex items-center gap-3 rounded-full bg-emerald-600 px-7 py-4 text-sm font-bold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-emerald-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:text-base" data-id="element-87" data-mp="bnjdjbhzulh1">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-88" data-mp="3141wa9unzcib" />
          Mandame un mensaje: {WHATSAPP_NUMBER}
        </a>

        <blockquote className="mx-auto mt-8 max-w-lg border-t border-ink-950/10 pt-7 text-base font-semibold italic leading-relaxed text-ink-950 sm:text-lg" data-id="element-89" data-mp="365hgy0sxjh06">
          “No hay preguntas tontas; tonto es quedarse con la duda.”
        </blockquote>

        <p className="mt-7 flex flex-wrap items-center justify-center gap-2 text-xs text-ink-950/45" data-id="element-90" data-mp="qcio0rqppl0t">
          <MailIcon className="h-4 w-4 text-ink-950/35" aria-hidden="true" data-id="element-91" data-mp="uex4j56ws8ox" />
          También podés escribirnos a
          <a href="mailto:atencionstockdigital@gmail.com" className="font-semibold text-ink-950/70 underline decoration-ink-950/20 underline-offset-4 transition-colors hover:text-ink-950" data-id="element-92" data-mp="23cn3gss9x5lc">
            atencionstockdigital@gmail.com
          </a>
        </p>
      </div>
    </Section>;
}